/* GHISAI v8.1: cinematic, faster on phones */
(() => {
  const d = document, $ = (s, r = d) => r.querySelector(s), $$ = (s, r = d) => [...r.querySelectorAll(s)];
  d.documentElement.classList.add('js');
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const money = c => '₹' + (c / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 });
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
  const lerp = (a, b, t) => a + (b - a) * t;
  const ease = t => t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

  /* smooth scroll: desktop mouse only */
  let lenis = null;
  const startLenis = () => {
    if (reduce || !fine || !window.Lenis || lenis) return;
    lenis = new window.Lenis({ lerp: .1, smoothWheel: true });
    const raf = t => { lenis.raf(t); requestAnimationFrame(raf); };
    requestAnimationFrame(raf);
  };
  if (window.Lenis) startLenis(); else addEventListener('load', startLenis);
  d.addEventListener('click', e => {
    const a = e.target.closest('a[href^="#"], a[href^="/#"]');
    if (!a) return;
    const id = a.getAttribute('href').split('#')[1]; const t = id && d.getElementById(id);
    if (!t || (a.getAttribute('href').startsWith('/#') && location.pathname !== '/')) return;
    e.preventDefault();
    if (lenis) lenis.scrollTo(t, { offset: 0, duration: 1.4 }); else t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' });
  });

  /* header */
  const hdr = $('[data-hdr]'), isHome = d.body.classList.contains('t-index');
  const mbar = $('[data-mbar]'), hero = $('[data-hero]'), drop = $('#drop');
  let lastY = scrollY;
  const onScroll = () => {
    const y = scrollY;
    if (hdr) {
      if (isHome) hdr.classList.toggle('solid', y > 60);
      if (!d.body.classList.contains('lock')) hdr.classList.toggle('up', y > 300 && y > lastY + 2 ? true : (y < lastY - 2 ? false : hdr.classList.contains('up')));
    }
    if (mbar && hero) {
      const past = y > hero.offsetHeight * .7;
      const r = drop ? drop.getBoundingClientRect() : null;
      const inDrop = r && r.top < innerHeight * .6 && r.bottom > innerHeight * .3;
      const rbx = $('[data-rb]'), rr = rbx ? rbx.getBoundingClientRect() : null;
      const inRb = rr && rr.top < innerHeight && rr.bottom > 0;
      const show = past && !inDrop && !inRb;
      mbar.classList.toggle('show', show); mbar.setAttribute('aria-hidden', show ? 'false' : 'true');
      const b = $('a', mbar); if (b) b.tabIndex = show ? 0 : -1;
    }
    lastY = y;
  };
  let tick = false;
  addEventListener('scroll', () => { if (!tick) { tick = true; requestAnimationFrame(() => { onScroll(); tick = false; }); } }, { passive: true });
  onScroll();

  /* overlays */
  let lastFocus = null;
  const open = el => {
    if (!el) return;
    lastFocus = d.activeElement;
    el.classList.add('open'); el.setAttribute('aria-hidden', 'false'); d.body.classList.add('lock');
    if (lenis) lenis.stop();
    if (hdr) hdr.classList.remove('up');
    const f = $('button, a, input', $('[role=dialog]', el) || el); if (f) setTimeout(() => f.focus({ preventScroll: true }), 80);
  };
  const close = el => {
    if (!el || !el.classList.contains('open')) return;
    el.classList.remove('open'); el.setAttribute('aria-hidden', 'true');
    if (!$('.menu.open, .sheet.open')) { d.body.classList.remove('lock'); if (lenis) lenis.start(); }
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  };
  const menu = $('[data-menu]'), cartEl = $('[data-cart]');
  d.addEventListener('click', e => {
    const t = e.target.closest('[data-menu-open],[data-menu-close],[data-sheet-open],[data-sheet-close],[data-cart-open],[data-cart-close]');
    if (!t) return;
    if (t.matches('[data-menu-open]')) { e.preventDefault(); open(menu); }
    else if (t.matches('[data-menu-close]')) close(menu);
    else if (t.matches('[data-sheet-open]')) { e.preventDefault(); open(d.getElementById(t.dataset.sheetOpen)); }
    else if (t.matches('[data-sheet-close]')) close(t.closest('.sheet'));
    else if (t.matches('[data-cart-open]')) { if (cartEl) { e.preventDefault(); renderCart(); open(cartEl); } }
    else if (t.matches('[data-cart-close]')) close(cartEl);
  });
  d.addEventListener('keydown', e => { if (e.key === 'Escape') $$('.menu.open, .sheet.open').forEach(close); });

  /* videos: play only while on screen; lazy sources */
  const vids = $$('video');
  if ('IntersectionObserver' in window && vids.length) {
    const vo = new IntersectionObserver(es => es.forEach(e => {
      const v = e.target;
      if (e.isIntersecting && getComputedStyle(v).display !== 'none') {
        if (v.dataset.src && !v.src) { v.src = v.dataset.src; }
        const p = v.play(); if (p && p.catch) p.catch(() => {});
      } else if (!v.paused) v.pause();
    }), { threshold: .15 });
    vids.forEach(v => vo.observe(v));
  }

  /* hero entrance */
  if (hero) {
    const go = () => hero.classList.add('on');
    const v = $$('video', hero).find(x => getComputedStyle(x).display !== 'none');
    if (v && v.readyState < 2) { v.addEventListener('loadeddata', go, { once: true }); setTimeout(go, 1200); } else setTimeout(go, 150);
  }

  /* reveal on view */
  const reveal = (sel, cls, th = .3) => {
    const els = $$(sel); if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(x => x.classList.add(cls)); return; }
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add(cls); io.unobserve(e.target); } }), { threshold: th });
    els.forEach(x => io.observe(x));
  };
  reveal('[data-vd]', 'in', .35);
  reveal('.td[data-draw]', 'on', .3);

  /* case-file fill-in */
  const today = new Date().toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }).toUpperCase();
  $$('[data-today]').forEach(x => x.textContent = today);
  const forms = $$('.form');
  forms.forEach(f => $$('.form-rows li, .form-remark', f).forEach((li, i) => li.style.setProperty('--i', i)));
  if (forms.length && 'IntersectionObserver' in window && !reduce) {
    const fo = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('on'); fo.unobserve(e.target); } }), { threshold: .35 });
    forms.forEach(f => { f.classList.add('wait'); fo.observe(f); });
  }

  /* ship countdown */
  $$('[data-ship]').forEach(s => {
    const [Y, M, D] = s.dataset.ship.split('-').map(Number); const n = new Date(); const days = Math.round((Date.UTC(Y, M - 1, D) - Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())) / 864e5);
    const b = $('b', s); if (b && days > 1) b.textContent = days + ' days';
  });

  /* read the back: pinned, scroll-scrubbed zoom into the print */
  const rb = $('[data-rb]');
  if (rb) try {
    const steps = JSON.parse(rb.dataset.steps);
    const stage = $('.rb-stage', rb), imgs = $$('.rb-img', rb), tabs = $$('[data-rb-tab]', rb);
    const capsets = $$('[data-rb-caps]', rb), bars = $$('.rb-bar b', rb);
    const link = $('[data-rb-link]', rb), name = $('[data-rb-name]', rb);
    let k = 0, cur = { s: 1, x: 0, y: 0 }, active = -1, visible = false;
    const RATIO = 1856 / 2304;
    const tf = (st, W, H) => {
      if (!st.z) return { s: 1, x: 0, y: 0 };
      let dw, dh, ox = 0, oy = 0;
      if (W / H > RATIO) { dw = W; dh = W / RATIO; oy = (H - dh) / 2; } else { dh = H; dw = H * RATIO; ox = (W - dw) / 2; }
      const px = ox + st.x * dw, py = oy + st.y * dh;
      const sFit = Math.max(1.25, (W * (W >= 900 ? .86 : .96)) / (.37 * dw));
      const s = sFit * st.z, tx = W / 2, ty = W >= 900 ? H * .5 : H * .34;
      return { s, x: tx - s * px, y: ty - s * py };
    };
    const setTab = i => {
      k = i;
      tabs.forEach((t, j) => t.setAttribute('aria-selected', j === i ? 'true' : 'false'));
      imgs.forEach((im, j) => { im.style.transition = 'opacity .6s'; im.style.opacity = j === i ? 1 : 0; });
      capsets.forEach((c, j) => c.hidden = j !== i);
      if (link) { link.href = link.dataset['u' + i]; }
      if (name) name.textContent = link.dataset['n' + i];
      active = -1;
    };
    tabs.forEach((t, i) => t.addEventListener('click', () => setTab(i)));
    const frame = () => {
      if (!visible) return;
      const r = rb.getBoundingClientRect(), W = stage.clientWidth, H = stage.clientHeight;
      const p = clamp(-r.top / Math.max(1, r.height - innerHeight));
      const kk = p * (steps[k].length - 1), i = Math.min(Math.floor(kk), steps[k].length - 2), f = kk - i;
      const t = ease(clamp((f - .2) / .6));
      const A = tf(steps[k][i], W, H), B = tf(steps[k][i + 1], W, H);
      const tgt = { s: lerp(A.s, B.s, t), x: lerp(A.x, B.x, t), y: lerp(A.y, B.y, t) };
      const a = reduce ? 1 : .14;
      cur = { s: lerp(cur.s, tgt.s, a), x: lerp(cur.x, tgt.x, a), y: lerp(cur.y, tgt.y, a) };
      imgs.forEach(im => { im.style.transformOrigin = '0 0'; im.style.transform = `translate3d(${cur.x}px,${cur.y}px,0) scale(${cur.s})`; });
      const act = f < .5 ? i : i + 1;
      if (act !== active) { active = act; $$('.rb-cap', capsets[k]).forEach((c, j) => c.classList.toggle('on', j === act)); }
      bars.forEach((b, j) => b.style.transform = `scaleX(${clamp(kk - j + 1)})`);
      requestAnimationFrame(frame);
    };
    new IntersectionObserver(([e]) => { visible = e.isIntersecting; if (visible) requestAnimationFrame(frame); }).observe(rb);
    setTab(0);
  } catch (x) { console.warn('rb', x); }

  /* film: words light up as you scroll */
  $$('[data-film]').forEach(f => {
    const ws = $$('[data-words] span', f);
    const run = () => {
      const r = f.getBoundingClientRect();
      const p = clamp((innerHeight - r.top) / (innerHeight + r.height * .35));
      const on = Math.floor(p * ws.length * 1.25);
      ws.forEach((w, i) => w.classList.toggle('on', i < on));
    };
    addEventListener('scroll', () => requestAnimationFrame(run), { passive: true }); run();
  });

  /* drag rail (mouse) */
  $$('[data-rail]').forEach(r => {
    let down = false, sx = 0, sl = 0, moved = false;
    r.addEventListener('mousedown', e => { down = true; moved = false; sx = e.pageX; sl = r.scrollLeft; r.classList.add('drag'); });
    addEventListener('mouseup', () => { down = false; r.classList.remove('drag'); });
    r.addEventListener('mousemove', e => { if (!down) return; const dx = e.pageX - sx; if (Math.abs(dx) > 4) moved = true; r.scrollLeft = sl - dx; });
    r.addEventListener('click', e => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
  });

  /* cursor */
  const cur = $('.cur');
  if (cur && fine && !reduce) {
    const lab = $('span', cur); let mx = -100, my = -100, cx = -100, cy = -100;
    addEventListener('mousemove', e => { mx = e.clientX; my = e.clientY; }, { passive: true });
    const loop = () => { cx = lerp(cx, mx, .2); cy = lerp(cy, my, .2); cur.style.transform = `translate3d(${cx}px,${cy}px,0)`; requestAnimationFrame(loop); };
    loop();
    d.addEventListener('mouseover', e => { const t = e.target.closest('[data-cursor]'); cur.classList.toggle('big', !!t); if (t) lab.textContent = t.dataset.cursor; });
    d.addEventListener('mouseleave', () => cur.classList.add('hide')); d.addEventListener('mouseenter', () => cur.classList.remove('hide'));
  }

  /* gallery */
  const gal = $('[data-gal]');
  if (gal) {
    const tr = $('[data-gal-track]', gal), out = $('[data-gal-i]', gal), segs = $$('.gal-segs i', gal);
    tr.addEventListener('scroll', () => { const i = Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth)); if (out) out.textContent = i + 1; segs.forEach((s, k) => s.classList.toggle('on', k <= i)); }, { passive: true });
  }

  /* add to bag */
  const add = async (id, qty = 1) => {
    const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: qty }] }) });
    const j = await r.json(); if (!r.ok) throw new Error(j.description || j.message || 'Could not add to bag. Try again.');
    await renderCart(+id); open(cartEl);
  };

  /* quick add on product panels */
  $$('[data-qa]').forEach(f => {
    const vmap = JSON.parse($('[data-qa-v]', f).textContent), btn = $('[data-qa-btn]', f), lbl = $('span', btn), msg = $('[data-qa-msg]', f), idIn = $('[data-qa-id]', f);
    const price = $('.vd-price', f.closest('.vd')); const pr = price ? price.firstChild.textContent.trim() : '';
    f.addEventListener('change', () => { const c = $('input:checked', f); if (!c) return; const v = vmap[c.value]; idIn.value = v ? v[0] : ''; lbl.textContent = `Add size ${c.value} to bag`; msg.textContent = ''; });
    f.addEventListener('submit', async e => {
      e.preventDefault();
      if (!idIn.value) { msg.textContent = 'Pick your size first.'; const ch = $('.chips', f); ch.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-6px)' }, { transform: 'translateX(6px)' }, { transform: 'translateX(0)' }], { duration: 300 }); return; }
      btn.classList.add('busy');
      try { await add(idIn.value); } catch (x) { msg.textContent = x.message; }
      btn.classList.remove('busy');
    });
  });

  /* product form */
  const pf = $('[data-pform]');
  let pdpSize = null;
  if (pf) {
    const vars = JSON.parse($('[data-variants]', pf).textContent);
    const stock = JSON.parse($('[data-stock]', pf).textContent || '{}');
    const vid = $('[data-vid]', pf), atc = $('[data-atc]', pf), left = $('[data-left]', pf), err = $('[data-err]', pf);
    const sets = $$('[data-opt]', pf), prices = $$('[data-price]');
    const sbar = $('[data-sbar]'), sbtn = $('[data-sbar-btn]'), ssize = $('[data-sbar-size]');
    const chosen = () => sets.map(f => { const c = $('input:checked', f); return c ? c.value : null; });
    const sync = () => {
      const sel = chosen(); pdpSize = sel[0];
      const v = vars.find(x => x.options.every((o, k) => o === sel[k]));
      sets.forEach((f, k) => {
        const lab = $('[data-opt-v]', f); if (lab) lab.textContent = sel[k] || '';
        $$('input', f).forEach(inp => {
          const ok = vars.some(x => x.available && x.options[k] === inp.value && x.options.every((o, j) => j === k || !sel[j] || o === sel[j]));
          inp.nextElementSibling.classList.toggle('na', !ok);
        });
      });
      if (!v) { atc.disabled = true; atc.firstElementChild.textContent = 'Unavailable'; return; }
      vid.value = v.id;
      prices.forEach(p => p.textContent = money(v.price));
      atc.disabled = !v.available; if (sbtn) sbtn.disabled = !v.available;
      atc.firstElementChild.textContent = v.available ? `Pre-order size ${v.title}` : atc.dataset.sold;
      if (sbtn) sbtn.textContent = v.available ? `Pre-order ${v.title}` : atc.dataset.sold;
      const q = stock[v.id];
      left.textContent = v.available && q > 0 && q <= 5 ? `Only ${q} left in ${v.title}` : '';
      if (ssize) ssize.textContent = sets.length ? ` / Size ${v.title}` : '';
      try { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (_) {}
    };
    pf.addEventListener('change', sync);
    if (sets.length) sync();
    pf.addEventListener('submit', async e => {
      e.preventDefault();
      if (!cartEl) return pf.submit();
      err.hidden = true; atc.classList.add('busy');
      try { await add(vid.value); } catch (x) { err.textContent = x.message; err.hidden = false; }
      atc.classList.remove('busy');
    });
    if (sbar && sbtn) {
      const buy = $('.buy', pf);
      if ('IntersectionObserver' in window) new IntersectionObserver(([e]) => { const show = !e.isIntersecting && e.boundingClientRect.top < 0; sbar.classList.toggle('show', show); sbar.setAttribute('aria-hidden', show ? 'false' : 'true'); sbtn.tabIndex = show ? 0 : -1; }).observe(buy);
      sbtn.addEventListener('click', () => pf.requestSubmit ? pf.requestSubmit() : pf.submit());
    }
  }

  /* complete the set on the product page */
  const xs = $('[data-xsell]');
  if (xs) {
    const vmap = JSON.parse(xs.dataset.v), b = $('[data-xsell-add]', xs);
    const pick = () => { const v = pdpSize && vmap[pdpSize] && vmap[pdpSize][1] ? vmap[pdpSize] : Object.values(vmap).find(x => x[1]); return v ? v[0] : null; };
    b.addEventListener('click', async () => { const id = pick(); if (!id) return; b.classList.add('busy'); try { await add(id); } catch (_) {} b.classList.remove('busy'); });
  }

  /* bag */
  const catalog = (() => { try { return JSON.parse($('[data-catalog]').textContent); } catch (_) { return []; } })();
  const esc = s => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const setCount = n => $$('[data-count]').forEach(c => { c.textContent = n; c.classList.toggle('has', n > 0); });
  async function renderCart(fresh) {
    if (!cartEl) return;
    let c;
    try { c = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json(); } catch (_) { return; }
    setCount(c.item_count);
    const lines = $('[data-lines]', cartEl), foot = $('[data-foot]', cartEl), cx = $('[data-cx]', cartEl);
    if (!c.item_count) {
      lines.innerHTML = `<div class="empty"><p class="d3">Your bag is empty.</p><p class="small">Drop 001 is two tees. Any 2 for ₹4,499.</p><a class="btn" href="${root}collections/drop-001"><span>Shop Drop 001</span></a></div>`;
      foot.hidden = true; cx.hidden = true; return;
    }
    lines.innerHTML = c.items.map((it, k) => {
      const img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_240x$1$2') : '';
      const opt = it.variant_title && it.variant_title !== 'Default Title' ? `Size ${esc(it.variant_title)}` : '';
      const isNew = fresh && it.variant_id === fresh;
      return `<div class="line${isNew ? ' new' : ''}" data-k="${k + 1}">${isNew ? '<span class="filed" aria-hidden="true">FILED <i lang="hi">दर्ज</i></span>' : ''}
        <a href="${esc(it.url)}">${img ? `<img src="${esc(img)}" alt="" width="84" height="104" loading="lazy">` : ''}</a>
        <div><a class="line-t" href="${esc(it.url)}">${esc(it.product_title)}</a><p class="small">${opt}</p>
          <div class="qty"><button type="button" data-q="${it.quantity - 1}" aria-label="One less">&minus;</button><span>${it.quantity}</span><button type="button" data-q="${it.quantity + 1}" aria-label="One more">+</button></div></div>
        <p class="line-p">${money(it.original_line_price)}</p></div>`;
    }).join('');
    $('[data-total]', cartEl).textContent = money(c.total_price);
    const disc = $('[data-disc]', cartEl), dv = $('[data-disc-v]', cartEl), nudge = $('[data-nudge]', cartEl);
    if (disc) { disc.hidden = !(c.total_discount > 0); if (dv) dv.textContent = '−' + money(c.total_discount); }
    if (nudge) nudge.hidden = !(c.item_count === 1);
    foot.hidden = false;
    const ids = c.items.map(i => i.product_id), size = c.items[0] && c.items[0].variant_title;
    const miss = catalog.find(p => !ids.includes(p.id) && Object.values(p.v).some(v => v[1]));
    if (miss) {
      const v = (size && miss.v[size] && miss.v[size][1]) ? [size, miss.v[size][0]] : Object.entries(miss.v).filter(e => e[1][1]).map(e => [e[0], e[1][0]])[0];
      $('[data-cx-row]', cartEl).innerHTML = `<div class="cx-row"><a href="${esc(miss.url)}">${miss.img ? `<img src="${esc(miss.img)}" alt="">` : ''}</a><div><b>${esc(miss.title)}</b><span>${money(miss.price)}, size ${esc(v[0])}</span></div><button type="button" class="btn btn--ghost" data-cx-add="${v[1]}"><span>Add</span></button></div>`;
      cx.hidden = false;
    } else cx.hidden = true;
  }
  if (cartEl) cartEl.addEventListener('click', async e => {
    const a = e.target.closest('[data-cx-add]');
    if (a) { a.classList.add('busy'); try { await add(a.dataset.cxAdd); } catch (_) {} return; }
    const b = e.target.closest('[data-q]'); if (!b) return;
    const line = +b.closest('.line').dataset.k; b.closest('.line').style.opacity = .5;
    await fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line, quantity: Math.max(0, +b.dataset.q) }) });
    renderCart();
  });

  /* checkout: Razorpay Magic Checkout when present */
  d.addEventListener('click', async e => {
    const c = e.target.closest('[name=checkout]');
    if (!c || typeof window.openRzpCheckout !== 'function') return;
    e.preventDefault(); e.stopPropagation();
    const note = $('#note');
    if (note) { try { await fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) }); } catch (_) {} }
    try { close(cartEl); window.openRzpCheckout(e); } catch (_) { location.href = root + 'checkout'; }
  }, true);

  /* cart page qty */
  $$('[data-cart-page] [data-q]').forEach(b => b.addEventListener('click', async () => {
    await fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: +b.dataset.line, quantity: Math.max(0, +b.dataset.q) }) });
    location.reload();
  }));
})();
